import { render } from "./Recibo.vue?vue&type=template&id=bad6a61e&scoped=true"
import script from "./Recibo.vue?vue&type=script&lang=js"
export * from "./Recibo.vue?vue&type=script&lang=js"

import "./Recibo.vue?vue&type=style&index=0&id=bad6a61e&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-bad6a61e"]])

export default __exports__
import QAvatar from 'quasar/src/components/avatar/QAvatar.js';
import QTable from 'quasar/src/components/table/QTable.js';
import qInstall from "../../../../node_modules/@quasar/app-webpack/lib/webpack/runtime.auto-import.js";
qInstall(script, 'components', {QAvatar,QTable});
